import script from "./AuthCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthCard.vue?vue&type=script&setup=true&lang=js"

import "./AuthCard.vue?vue&type=style&index=0&id=2f7b0a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7b0a10"]])

export default __exports__